import axios from "axios";
import { toast } from "react-toastify";

const URL = "/portal/rest/contador"
export const URL_whatsapp = "https://whatsapp.meucontadoronline.com.br/whatsapp-mco/"


const URL_CONTEXTO = "/portal/rest"
const URL_REST = "/portal/rest"
const URL_PIX = "/merp/rest/bb/os"
const URL_BOLETO = "/merp/rest/itau"
const URL_IBGE = "/portal/rest/ibge/"
const URL_API = "/portal/rest/empresa/receita-federal"
const URL_TESTE = "http://localhost:8080"

const URL_CEP = "https://viacep.com.br/ws"

//https://uat01.meucontadoronline.com.br

const URL_MERP_REST = "/merp/rest/";

const URL_API_MERP = "/merp/rest/empresa"

const POST_API_CERTIFICADO = axios.create({
  baseURL: URL_whatsapp,
  headers: {
    "Content-Type": "application/json",
  },
})

const POST_API_CONTEXTO = axios.create({
  baseURL: URL_CONTEXTO,
  headers: {
    responseType: 'blob',
  },
  withCredentials: true,
});

const GET_API_CONTEXTO = axios.create({
  baseURL: URL_CONTEXTO,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});


const POST_API = axios.create({
  baseURL: URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

const POST_API_REST = axios.create({
  baseURL: URL_REST,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});


const GERAR_PIX = axios.create({
  baseURL: URL_PIX,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

const GERAR_BOLETO = axios.create({
  baseURL: URL_BOLETO,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

const IBGE = axios.create({
  baseURL: URL_IBGE,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

const config_API = axios.create({
  baseURL: URL_API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

const config_API_MERP = axios.create({
  baseURL: URL_API_MERP,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});


const config_CEP = axios.create({
  baseURL: URL_CEP,
  headers: {
    "Content-Type": "application/json",
  },
});



const POST_API_WHATSAPP = axios.create({
  baseURL: URL_whatsapp,
  withCredentials: true, // ✅ necessário
  headers: {
    "Content-Type": "application/json"
  }
});

const MERP_REST = axios.create({
  baseURL: URL_MERP_REST,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});


const Method_POST_CONTEXTO = async (url, config = {}) => {
  try {
    const response = await POST_API_CONTEXTO.post(url, config);

    if (response.status === 200 || response.status === 204) {
      if (response.data == null || (Array.isArray(response.data) && response.data.length === 0)) {
        return { message: "Nenhum dado encontrado" };
      }
      return response.data;
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        case 409:
          throw new Error(
            typeof error.response.data === "string"
              ? error.response.data
              : error.response.data?.message || "Conflito de dados (409)"
          );
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

const Method_POST = async (url, config = {}) => {
  try {
    const response = await POST_API.post(url, config);

    if (response.status === 200 || response.status === 204) {
      if (response.data == null || (Array.isArray(response.data) && response.data.length === 0)) {
        return { message: "Nenhum dado encontrado" };
      }
      return response.data;
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

//caso você queira que ele retorna apenas uma mensagem sucess quando o status for 204
const Method_POST_REST = async (url, config = {}) => {
  try {
    const response = await POST_API_REST.post(url, config);

    if (response.status === 204) {
      // Caso o status seja 204, retornamos uma mensagem específica
      return { message: "Requisição bem-sucedida, mas sem conteúdo retornado." };
    }

    if (response.status === 200) {
      // Verifica se os dados estão presentes no corpo da resposta
      if (
        response.data == null ||
        (Array.isArray(response.data) && response.data.length === 0)
      ) {
        return { message: "Nenhum dado encontrado" };
      }
      return response.data;
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }
  } catch (error) {
    if (error.response) {
      // Lida com os erros de status conhecidos
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error(
            `Erro ${error.response.status} - ${error.response.statusText}`
          );
      }
    }
    // Lida com outros erros (como problemas de rede)
    throw error;
  }
};

const POST_Remove_arquivo = async (url, config = {}) => {
  try {
    const response = await POST_API.post(url, config);
    if (response.status === 200 || response.status === 204) {
      toast.success("Arquivo excluído com sucesso!");
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

const POST_Remove_arquivo_context = async (url, config = {}) => {
  try {
    const response = await POST_API_CONTEXTO.post(url, config);
    if (response.status === 200 || response.status === 204) {
      toast.success("Arquivo excluído com sucesso!");
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

const pix_Generator = async (url, config = {}) => {
  try {
    const response = await GERAR_PIX.post(url, config);
    if (response.status === 200) {
      if (!response.data == null || (Array.isArray(response.data) && response.data.length === 0)) {
        return { message: "Nenhum dado carregado" };
      }
      return response.data;
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

const boleto_Generator = async (url, config = {}) => {
  try {
    const response = await GERAR_BOLETO.post(url, config);
    if (response.status === 200) {
      if (!response.data == null || (Array.isArray(response.data) && response.data.length === 0)) {
        return { message: "Nenhum dado carregado" };
      }
      return response.data;
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

const ibge_POST = async (url, config = {}) => {
  try {
    const response = await IBGE.post(url, config);
    if (response.status === 200 || response.status === 204) {
      if (response.data == null || (Array.isArray(response.data) && response.data.length === 0)) {
        return { message: "Nenhum dado encontrado" };
      }
      return response.data;
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

const buscarClienteReceitaFederal_MERP = async (url) => {  // Removido o segundo argumento 'config'
  try {
    const response = await config_API_MERP.get(url);  // Usar 'GET' para buscar dados com parâmetros na URL

    if (response.status === 200 || response.status === 204) {
      if (response.data == null || (Array.isArray(response.data) && response.data.length === 0)) {
        return { message: "Nenhum dado encontrado" };
      }
      return response.data;
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

const buscarClienteReceitaFederal = async (url) => {  // Removido o segundo argumento 'config'
  try {
    const response = await config_API.get(url);  // Usar 'GET' para buscar dados com parâmetros na URL

    if (response.status === 200 || response.status === 204) {
      if (response.data == null || (Array.isArray(response.data) && response.data.length === 0)) {
        return { message: "Nenhum dado encontrado" };
      }
      return response.data;
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

const buscarCEP = async (url) => {
  try {
    const response = await config_CEP.get(url);

    if (response.status === 200 || response.status === 204) {
      if (!response.data || response.data.erro) {
        return { message: "CEP não encontrado" };
      }
      return response.data;
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

const Method_GET_CONTEXTO = async (url, config = {}) => {
  try {
    const response = await GET_API_CONTEXTO.get(url, config);

    if (response.status === 200 || response.status === 204) {
      if (response.data == null || (Array.isArray(response.data) && response.data.length === 0)) {
        return { message: "Nenhum dado encontrado" };
      }
      return response.data;
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

const Method_POST_PDF = async (url, payload = {}) => {
  try {
    // Faz a requisição passando responseType 'blob' para receber PDF
    const response = await POST_API_CONTEXTO.post(url, payload, {
      responseType: "blob",
    });

    if (response.status === 200 || response.status === 204) {
      if (!response.data || response.data.size === 0) {
        return { message: "Nenhum PDF encontrado" };
      }
      return response.data; // Retorna Blob do PDF
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }
  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};


const Method_POST_UPLOAD = async (url, file) => {
  if (!file) throw new Error("Nenhum arquivo selecionado");

  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await POST_API_CONTEXTO.post(url, formData); // sem headers

    return response.data || { message: "Nenhum dado retornado" };
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const mensagem =
        status === 403
          ? "Erro 403 - Acesso negado"
          : status === 404
            ? "Erro 404 - Não encontrado"
            : status === 500
              ? "Erro 500 - Erro no servidor"
              : `Erro ${status} - Problema na requisição`;
      throw new Error(mensagem);
    }
    throw error;
  }
};

export const Method_POST_CERTIFICADO = async (url, payload = {}) => {
  try {
    const response = await POST_API_CERTIFICADO.post(url, payload);
    return response.data;
  } catch (error) {
    console.error('Erro Biometria:', error.response || error);
    throw error;
  }
};

export const Method_POST_WHATSAPP = async (url, config = {}) => {
  try {
    const response = await POST_API_WHATSAPP.post(url, config);

    if (response.status === 200 || response.status === 204) {
      if (!response.data || (Array.isArray(response.data) && response.data.length === 0)) {
        return { message: "Nenhum dado encontrado" };
      }
      return response.data;
    } else {
      toast.error(`Erro ${response.status} - Problema na requisição`);
    }
  } catch (error) {
    handleError(error)
    throw error;
  }
};

export const Method_GET_CONTEXTO_PDF = async (url, config = {}) => {
  try {
    // força blob
    const response = await GET_API_CONTEXTO.get(url, { ...config, responseType: 'blob' });

    if (response.status === 200) {
      return response; // já é Blob
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403: throw new Error("Erro 403 - Acesso negado");
        case 404: throw new Error("Erro 404 - Não encontrado");
        case 500: throw new Error("Erro 500 - Erro no servidor");
        default: throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

export const PIX_MERP_REST = async (url, config = {}) => {
  try {
    const response = await MERP_REST.post(url, config);
    if (response.status === 200) {
      if (!response.data == null || (Array.isArray(response.data) && response.data.length === 0)) {
        return { message: "Nenhum dado carregado" };
      }
      return response.data;
    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

export const POST_MERP_REST = async (url, config = {}) => {
  try {
    const response = await MERP_REST.post(url, config);
    if (response.status === 200 || response.status === 204) {

      if (response.status === 204) {
        return { message: "Requisição efetuada com sucesso (204 No Content)" };
      }

      if (response.status === 200) {
        // Sua lógica original de validação de dados
        if (response.data == null || (Array.isArray(response.data) && response.data.length === 0)) {
          return { message: "Nenhum dado carregado" };
        }
        return response.data;
      }

    } else {
      throw new Error(`Erro ${response.status} - Problema na requisição`);
    }

  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 403:
          throw new Error("Erro 403 - Acesso negado");
        case 404:
          throw new Error("Erro 404 - Não encontrado");
        case 500:
          throw new Error("Erro 500 - Erro no servidor");
        default:
          throw new Error("Erro desconhecido");
      }
    }
    throw error;
  }
};

export const handleError = (error) => {
  if (error.response) {
    switch (error.response.status) {
      case 403:
        toast.error("Erro 403 - Acesso negado", { autoClose: 3000 });

        // Isso garante que o toast aparece antes de iniciar o timeout real
        setTimeout(() => {
          setTimeout(() => {
            localStorage.clear();
            window.location = "#login";
          }, 3000); // só redireciona depois de 3 segundos
        }, 0);
        break;
      case 404:
        toast.error("Erro 404 - Não encontrado");
        break;
      case 500:
        toast.error("Erro 500 - Erro no servidor");
        break;
      default:
        toast.error(
          `Erro ${error.response.status} - ${error.response.statusText}`
        );
        break;
    }
  } else {
    toast.error("Erro na comunicação com o servidor: " + error.message);
  }
};


const Method_GET_DOWNLOAD_URL = async (path, fileName) => {
  try {
    const response = await GET_API_CONTEXTO.get(path, {
      responseType: 'blob'
    });

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || 'arquivo';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error) {
    console.error('Erro no download:', error);
    throw error;
  }
};

export { Method_POST, Method_POST_CONTEXTO, POST_Remove_arquivo_context, Method_GET_CONTEXTO, Method_POST_PDF, Method_POST_UPLOAD, Method_GET_DOWNLOAD_URL };
export { Method_POST_REST }
export { POST_Remove_arquivo }
export { pix_Generator }
export { boleto_Generator }
export { ibge_POST }
export { buscarClienteReceitaFederal }
export { buscarClienteReceitaFederal_MERP }
export { buscarCEP }

//variavel
export { URL }


